<template>
  <v-layout style="margin: 0px; margin-top: 2px" class="small-text" column wrap>
    <v-card style="padding: 8px 8px 8px 8px; font-size: 11px;" >
      <v-flex shrink justify-start>
        <v-row justify="space-between">
          <v-row><v-flex shrink>
            <span class="taxi-list-header mrc-mine-shaft font-weight-medium">
              Online:</span>
            {{ onlineTaxiCount }}&nbsp;&nbsp;&nbsp;
          </v-flex>
          <v-flex shrink>
            <b class="taxi-list-header mrc-mine-shaft font-weight-medium">Free:</b>
            {{ freeTaxiCount }}
          </v-flex>
          </v-row>
          <v-flex shrink v-if="!toggleDisabled">
            <v-btn @click="showZones" style="height: 12px; -webkit-box-shadow: none;" x-small>Zones</v-btn>
          </v-flex>
        </v-row>
      </v-flex>
      <v-flex v-for="rideType in enabledRideTypes">
        <v-layout column pt-1>
          <span>
            <b class="taxi-list-header font-weight-medium mrc-mine-shaft">{{rideType.name}}:</b>
            {{availableTaxisForRideTypes(rideType.id).length}} / {{taxisForRideTypes(rideType.id).length}}
            <b
              v-if="rideTypeEtas != null"
              v-bind:style="colorForRideTypeEta(rideType)"
            >{{ rideTypeEtas["ride_type_" + rideType.id] > 9999 ? "n/a" : rideTypeEtas["ride_type_" + rideType.id] + "m" }}</b>
          </span>
          <v-row>
            <div
              v-for="item in taxisForRideTypes(rideType.id)"
              @click="setSelectedTaxi(item.id)"
              style="cursor: pointer; margin-right: 4px;"
            >
              <v-menu
                right
                offset-x
                :close-on-content-click="false"
                v-model="menu[item.id.toString()]"
              >
                <template v-slot:activator="{ on }">
                  <div style="padding-top: 6.0px;">
                    <span
                      v-bind:style="selectedTaxiStyle(item)"
                      v-on="on"
                      v-html="stateForTaxi(item,)"
                    ></span>
                  </div>
                </template>
                <DriverMenu
                  @editBooking="editActiveBookingForTaxi(item)"
                  @message="message"
                  :taxi="item"
                  @close="menu[item.id.toString()] = false"
                />
              </v-menu>
            </div>
          </v-row>
        </v-layout>
      </v-flex>
      <v-dialog v-model="messageDialog" width="600px">
        <MessageDriverDialog @sent="messageDialog = false" :taxi="taxi" />
      </v-dialog>
    </v-card>
  </v-layout>
</template>

<script>
import DriverMenu from "@/components/widget/menu/DriverMenu.vue";

import { Overwatch } from "@/components/util/Overwatch.js";
import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";

export default {
  name: "taxi_list_overwatch",
  components: {
    DriverMenu,
    MessageDriverDialog
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    toggleDisabled: {
      type: Boolean,
      default: false
    },
    taxis: Array,
    bookings: Array,
    rideTypes: Array,
    rideTypeEtas: Object,
    setSelectedTaxi: Function,
    selectedTaxi: Number
  },
  computed: {
    enabledRideTypes: function() {
      if (this.rideTypes == null) {
        return [];
      }
      return this.rideTypes.filter(function(rt) {
        return rt.enabled == true;
      });
    },
    onlineTaxiCount: function() {

      var count = 0;

      for (var i = 0; i < this.taxis.length; i++) {
        if (this.taxis[i].offline == null || this.taxis[i].offline == false) {
          count++;
        }
      }

      return count;
    },
    freeTaxiCount: function() {
      var count = 0;

      for (var i = 0; i < this.taxis.length; i++) {
        if (this.taxis[i].state == 'available') {
          count++;
        }
      }

      return count;
    }
  },
  watch: {
    menu: {
      deep: true,
      handler() {
        console.log("PRESSED")
        console.log(this.menu);

        for (var i = 0; i < this.menu.length; i++) {
          if (this.menu[i] == true) {
            console.log( i );

            this.setSelectedTaxi( i );

            return;
          }
        }

        this.setSelectedTaxi( -1 );
      
      }
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: [],
      messageDialog: false,
      taxi: null
    };
  },
  methods: {
    editActiveBookingForTaxi(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      var job = ow.getJobForTaxi(taxi.id);

      if (job != null) {
        this.$emit("editBooking", job.id)
      }

      return null;
    },
    showZones: function() {
      this.$emit("showZones")
    },
    message: function(taxi) {
      console.log("Message dialog");
      this.messageDialog = true;
      this.taxi = taxi;
    },
    colorForRideTypeEta: function(rideType) {
      return {
        color:
          this.rideTypeEtas["ride_type_" + rideType.id] >
          rideType.availability_warning_threshold
            ? "lightcoral"
            : "limegreen"
      };
    },
    selectedTaxiStyle: function(taxi) {
      var style = {
        padding: "2px",
        borderRadius: "6px",
        border: "1px solid #dadada",
        textAlign: "center"
      };

      if (taxi.id == this.selectedTaxi) {
        style.color = "white";
        style.backgroundColor = "black";
      } else {
        var ow = new Overwatch(this.taxis, this.bookings);

        style.color = "black";
        style.backgroundColor = ow.colorForTaxi(taxi);
      }

      return style;
    },
    stateForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.stateForTaxi(taxi, this.$store.state.driverGroups);
    },
    availableTaxisForRideTypes: function(id, count) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(this.taxis, this.bookings);

      var self = this;
      var filters = this.$store.getters['overwatch/getBookingTypesFilter'];

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          console.log(t);

          if (t.currentBookingTaxi != null) {
            if (filters != null && filters != '') {
              return filters.includes(t.currentBookingTaxi.booking.booking_type);
            }
          } 

          return t.ride_type_id == id && t.state == "available";
        })
      );
    },
    taxisForRideTypes: function(id, count) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(this.taxis, this.bookings);

      var self = this;
      var filters = this.$store.getters['overwatch/getBookingTypesFilter'];

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          console.log(t);

          if (t.currentBookingTaxi != null) {
            if (filters != null && filters != '') {
              return t.ride_type_id == id && filters.includes(t.currentBookingTaxi.booking.booking_type);
            }
          } 

          return t.ride_type_id == id;
        })
      );
    },
    bookingsForRideTypes: function(id) {
      if (this.bookings == null) {
        return [];
      }

      return this.bookings.filter(function(b) {
        return b.ride_type == id;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}
</style>
